import { render } from "./overlapping-campaigns-list.vue?vue&type=template&id=65f68f76&ts=true"
import script from "./overlapping-campaigns-list.ts?vue&type=script&lang=ts&external"
export * from "./overlapping-campaigns-list.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__